const style = () => ({
	node: {
		minWidth: "100%",
		position: "relative",
	},
});

export default style;
